const Message = (that, message, type) => {
  that.$message({
    message,
    type
  })
}


export default Message



// WEBPACK FOOTER //
// ./src/common/Message.js